module.exports = __webpack_public_path__ + "static/img/case_10.ac93b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_10.jpg
// module id = 28mL
// module chunks = 0